export const FONT_SIZE = 10
export const GAP = 4
export const TEXT_BOX_RADIUS = 3

export const COLOR_BLACK = '#000000'
export const COLOR_WHITE = '#FFFFFF'

export const COLOR_PADDING = '#C2DCB6'
export const COLOR_BORDER = '#F5E1A3'
export const COLOR_MARGIN = '#F7CA9D'

export const COLOR_ABS = 'var(--color-absolute)'
export const COLOR_ABS_L = 'var(--color-absolute-light)'
export const COLOR_ABS_D = 'var(--color-absolute-dark)'
export const COLOR_GRID = 'var(--color-grid)'
export const COLOR_GRID_L = 'var(--color-grid-light)'
export const COLOR_GRID_D = 'var(--color-grid-dark)'
export const COLOR_FLEX = 'var(--color-flex)'
export const COLOR_FLEX_L = 'var(--color-flex-light)'
export const COLOR_FLEX_D = 'var(--color-flex-dark)'

export const LINE_DASHARRAY = '2 2'
export const LINE_STROKE_WIDTH = 1
